<template>
  <div>
    <base-card :with_title="false">
      <template slot="content">
        <v-data-table
          :headers="headers"
          :items="clients"
          class="elevation-0"
          :loading="loading"
          :search="search"
          hide-default-footer
        >
          <template v-slot:item.actions="{item}">
            <v-btn icon small color="primary" @click="showClient(item)">
              <v-icon small>mdi-pencil</v-icon>
            </v-btn>
          </template>
        </v-data-table>

      </template>
      <template></template>
    
    </base-card>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
//import validations from '@/mixins/validations'
import Api from '@/api/index';

export default {
  name: 'ClientList',
  //mixins: [ validations ],
  components: {
    //ComponentName: () => import(''),
  },
  data() {
    return {
      loading: false,
      clients: [],
      search: null,
      selectedRow: null,
      headers: [
        {text: 'Nome', value: 'name',},
        {text: 'CPF/CNPJ', value: 'document',},
        {text: 'Contato', value: 'json_attributes.phone',},
        {text: 'Email', value: 'json_attributes.email',},
        {text: this.$t('action'), value: 'actions', sortable: false},
      ],

      sortBy: '',
      sortDesc: null,
    }
  },
  methods: {
    getClients() {
      this.loading = true
      Api.Client.index().then(r=>r.data).then(d=> {
        this.clients = [...d]
      }).catch(err=> {
        console.log({err});
      }).finally(()=>{
        this.loading = false
      })
    },
    showClient(item){
      this.$router.push({name: 'ShowClient', params: {id: item.id}})
    },

    ...mapActions({
      // function: 'Module/action'
      //addNotification: 'Notification/add'
    })
  },
  computed: {
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
  mounted () {
    this.getClients();
  },
  watch: {
    '$route'(nv,ov) {
      // console.log({ov, nv});
      if (['ShowClient', 'NewClient'].includes(ov.name)){
        this.getClients()
      }
    }
  },
}
</script>

<style lang="scss" scoped>

</style>